/*---

  Scripts for the slideshow

  Louis-Charles Blais [info@22agencecreative.ca]

---*/


// function prevSlide() {
//   let slideshow = event.target.closest('.slideshow-container');
//   let slides = slideshow.querySelectorAll('.slide');
//   let index;

//   for (let i = 0; i < slides.length; i++) {
//     if (slides[i].classList.contains('active')) {
//       index = i;
//       slides[i].classList.remove('active');
//     }
//   }

//   if (index == 0) {
//     index = slides.length - 1;
//   } else {
//     index--;
//   }

//   slides[index].classList.add('active');
// }
function nextSlide() {
  let slideshow = document.querySelector('.slideshow-container');
  let slides = slideshow.querySelectorAll('.slide');
  let index;

  for (let i = 0; i < slides.length; i++) {
    if (slides[i].classList.contains('active')) {
      index = i;
      slides[i].classList.remove('active');
    }
  }

  if (index == (slides.length - 1)) {
    index = 0;
  } else {
    index++;
  }

  slides[index].classList.add('active');
}
setInterval(nextSlide, 8000);